var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand"},[_c('span',[_vm._v(_vm._s(_vm.brandName))]),_vm._v(" - 管理控制台 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }